import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import React from "react";

const DatePickerCustom2 = (props) => {

    const { sx, slotProps, ...otherProps } = props;

    return (
        <DatePicker
            label={'Mission Preferred'} 
            views={['month', 'year']}
            format="MMM-YY"  // Add the format prop here
            {...otherProps}
            sx={{
                ...sx,
                "& .MuiFormLabel-root, & .MuiFormLabel-root.Mui-disabled": {
                    color: "#252525",
                },
            }}
            slotProps={{
                textField: { placeholder: "MMM YY" },
                ...slotProps,
            }}
        />
    );
};

DatePickerCustom2.defaultProps = {
    sx: {},
};

export default DatePickerCustom2;
